import React, { useState } from 'react';
import './Switch.css';

const Switch = ({ isOn, handleToggle }) => {
  return (
    <label className="switch-label">
      <input
        className="switch-checkbox"
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
      />
      <span className="switch-button" />
    </label>
  );
};

export default Switch;